.small {
  --base-size: var(--cxy-spacing-0);
}

.medium {
  --base-size: var(--cxy-spacing-xxxsm);
}
.large {
  --base-size: var(--cxy-spacing-xxsm);
}

.spinner {
  --spinner-size: calc(var(--base-size) * 20);
  --spinner-height: calc(var(--base-size) * 4);
  --spinner-width: calc(var(--spinner-height) / 3);

  color: official;
  display: inline-block;
  position: relative;
  width: var(--spinner-size);
  height: var(--spinner-size);

  div {
    transform-origin: calc(var(--spinner-size) / 2) calc(var(--spinner-size) / 2);
    animation: spinner 1.2s linear infinite;

    &:nth-child(1) {
      transform: rotate(0deg);
      animation-delay: -1.1s;
    }

    &:nth-child(2) {
      transform: rotate(30deg);
      animation-delay: -1s;
    }

    &:nth-child(3) {
      transform: rotate(60deg);
      animation-delay: -0.9s;
    }

    &:nth-child(4) {
      transform: rotate(90deg);
      animation-delay: -0.8s;
    }

    &:nth-child(5) {
      transform: rotate(120deg);
      animation-delay: -0.7s;
    }

    &:nth-child(6) {
      transform: rotate(150deg);
      animation-delay: -0.6s;
    }

    &:nth-child(7) {
      transform: rotate(180deg);
      animation-delay: -0.5s;
    }

    &:nth-child(8) {
      transform: rotate(210deg);
      animation-delay: -0.4s;
    }

    &:nth-child(9) {
      transform: rotate(240deg);
      animation-delay: -0.3s;
    }

    &:nth-child(10) {
      transform: rotate(270deg);
      animation-delay: -0.2s;
    }

    &:nth-child(11) {
      transform: rotate(300deg);
      animation-delay: -0.1s;
    }

    &:nth-child(12) {
      transform: rotate(330deg);
      animation-delay: 0s;
    }

    &:after {
      background-color: var(--cxy-color-content-default);
      content: '';
      display: block;
      position: absolute;
      top: var(--base-size);
      left: calc(var(--spinner-size) / 2 - var(--base-size));
      width: var(--spinner-width);
      height: var(--spinner-height);
      border-radius: 20%;
    }
  }

  &.light {
    div:after {
      background-color: var(--cxy-color-content-default);
    }
  }

  &.dark {
    div:after {
      background-color: var(--cxy-color-content-contrast);
    }
  }
}

@keyframes spinner {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
